import { render, staticRenderFns } from "./_attachment.vue?vue&type=template&id=3d62aba4&lang=pug"
import script from "./_attachment.vue?vue&type=script&lang=js"
export * from "./_attachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports